import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Loader from '../../utils/Loader';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { studentGrade } from '../../utils/const';
import {
	addChildDetails,
	setShowAddChild,
} from '../../redux/parentDashboard/parentDashboard.actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import Zoom from '../utils/animations/zoom';
import { setErrorPanel } from '../../redux/utilities/utils.actions';
const AddChild = ({
	addChildDetails,
	panelClass,
	panelMsg,
	showAddChild,
	setShowAddChild,
	formType,
	setErrorPanel,
}) => {
	const { register, handleSubmit, watch, errors } = useForm();
	const [imgSrc, setImgSrc] = useState(['']);
	const onSubmit = (data) => {
		addChildDetails(data);
	};
	const watchChildPhoto = watch('child_photo', false);
	useEffect(() => {
		var reader = new FileReader();
		if (!!watchChildPhoto && !!watchChildPhoto[0]) {
			reader.readAsDataURL(watchChildPhoto[0]);
			reader.onloadend = () => setImgSrc([reader.result]);
		}
	}, [watchChildPhoto]);
	useEffect(() => {
		Loader.hide();
		setErrorPanel({
			errorPanel: {
				panelClass: '',
				panelMsg: '',
			},
		});
	}, [setErrorPanel]);
	return (
		<div>
			{!formType ? (
				<Modal
					show={showAddChild}
					dialogClassName="modal-90w"
					onHide={() => setShowAddChild(false)}
					backdrop={true}
					keyboard={false}
					style={{ minWidth: '300px' }}
					className="add-child-modal"
				>
					<Modal.Header closeButton style={{ minWidth: '300px' }}>
						<h4
							className="modal-title"
							style={{ width: '100%', textAlign: 'center' }}
						>
							Add Child
						</h4>
					</Modal.Header>
					<Modal.Body size="lg" style={{ minWidth: '300px' }}>
						<div className="message_box">
							<div className={panelClass}>{panelMsg}</div>
						</div>
						<form id="childProfileForm" onSubmit={handleSubmit(onSubmit)}>
							<div className="d-flex flex-column justify-content-center">
								<div className="form-group text-center" style={{ marginTop: '10px' }}>
									<label className="control-label" htmlFor="child_photo">
										<div className="profileImageContainer">
											<img
												className="profileImagePreview"
												alt="profile"
												src={
													!!watchChildPhoto && watchChildPhoto.length > 0
														? imgSrc
														: '/assets/img/kid-avatar-boy.svg'
												}
											/>
											<Zoom>
												<FontAwesomeIcon
													icon={faCamera}
													className="upload-button"
													size="lg"
												/>
											</Zoom>
										</div>
									</label>
									<input
										className="filepond"
										name="child_photo"
										id="child_photo"
										accept="image/*"
										ref={register}
										type="file"
										multiple={false}
										style={{ display: 'none' }}
									/>
								</div>
								<div className="form-group" style={{ marginTop: '10px' }}>
									<label className="control-label" htmlFor="child_name">
										Child's name:
									</label>
									<input
										type="text"
										className="form-control"
										name="child_name"
										ref={register({
											required: true,
											// eslint-disable-next-line no-useless-escape
											pattern: /^[a-zA-Z\s\.]+$/i,
										})}
									/>
									<span className="profileError">
										{errors.child_name?.type === 'pattern' &&
											'Name should only contain alphabets'}
									</span>
									<span className="profileError">
										{errors.child_name?.type === 'required' && "Child's name is required"}
									</span>
								</div>
							</div>
							<div className="form-group" style={{ marginTop: '10px' }}>
								<label className="control-label" htmlFor="child_grade">
									Which Class/Grade is your child in?
								</label>
								<select
									id="child_grade"
									name="child_grade"
									className="form-control"
									ref={register({
										required: true,
									})}
								>
									<option value="">Select Class:</option>
									{!!studentGrade &&
										studentGrade.map((val, index) => (
											<option value={index + 3} key={index}>
												{val}
											</option>
										))}
								</select>

								<span className="profileError">
									{errors.child_grade?.type === 'required' &&
										"Child's grade is required"}
								</span>
							</div>

							<Button type="submit" variant="primary">
								SAVE
							</Button>
						</form>
					</Modal.Body>
				</Modal>
			) : (
				<form id="childProfileForm" onSubmit={handleSubmit(onSubmit)}>
					<div className="d-flex flex-column justify-content-center">
						<div className="form-group text-center" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="child_photo">
								<div className="profileImageContainer">
									<img
										className="profileImagePreview"
										alt="profile"
										src={
											!!watchChildPhoto && watchChildPhoto.length > 0
												? imgSrc
												: '/assets/img/kid-avatar-boy.svg'
										}
									/>
									<Zoom>
										<FontAwesomeIcon
											icon={faCamera}
											className="upload-button"
											size="lg"
										/>
									</Zoom>
								</div>
							</label>
							<input
								className="filepond"
								name="child_photo"
								id="child_photo"
								accept="image/*"
								ref={register}
								type="file"
								multiple={false}
								style={{ display: 'none' }}
							/>
						</div>
						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="child_name">
								Child's name:
							</label>
							<input
								type="text"
								className="form-control"
								name="child_name"
								ref={register({
									required: true,
									// eslint-disable-next-line no-useless-escape
									pattern: /^[a-zA-Z\s\.]+$/i,
								})}
							/>
							<span className="profileError">
								{errors.child_name?.type === 'pattern' &&
									'Name should only contain alphabets'}
							</span>
							<span className="profileError">
								{errors.child_name?.type === 'required' && "Child's name is required"}
							</span>
						</div>
					</div>
					<div className="form-group" style={{ marginTop: '10px' }}>
						<label className="control-label" htmlFor="child_grade">
							Which Class/Grade?
						</label>
						<select
							id="child_grade"
							name="child_grade"
							className="form-control"
							ref={register({
								required: true,
							})}
						>
							<option value="">Select Class:</option>
							{!!studentGrade &&
								studentGrade.map((val, index) => (
									<option value={index + 3} key={index}>
										{val}
									</option>
								))}
						</select>

						<span className="profileError">
							{errors.child_grade?.type === 'required' && "Child's grade is required"}
						</span>
					</div>

					<Button type="submit" variant="primary">
						ADD
					</Button>
				</form>
			)}
		</div>
	);
};

const mapStateToProps = (state) => {
	const { errorPanel: { panelClass, panelMsg } = {} } = state.rootReducer.utils;
	const { showAddChild } = state.rootReducer.parentDetails;
	return {
		panelClass,
		panelMsg,
		showAddChild,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addChildDetails: (val) => dispatch(addChildDetails(val)),
		setShowAddChild: (val) => dispatch(setShowAddChild(val)),
		setErrorPanel: (errorText) => dispatch(setErrorPanel(errorText)),
	};
};

export default compose(
	withRouter,

	connect(mapStateToProps, mapDispatchToProps),
)(AddChild);
